import { useCurrentUser } from 'Auth';
import PresetFormDialog from 'components/Presets/PresetForm';
import {
  groupedPresets,
  renameGroup as renameGroupKey,
} from 'components/Presets/data/queryKeyFactory';
import { editGroup } from 'components/Presets/sources/presets';

import { useMutation, useQueryClient } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

export const useRenameGroup = (presetKey) => {
  const showModal = useScreenModalV2(PresetFormDialog);

  const currentUser = useCurrentUser();
  const queryClient = useQueryClient();

  const renameMutation = useMutation(
    renameGroupKey(presetKey),
    (group) =>
      editGroup({
        ...group,
        screen: presetKey,
      }),
    {
      successMessage: () => 'Preset group renamed',
      onMutate: async (newGroup) => {
        try {
          queryClient.setQueriesData(
            { queryKey: groupedPresets({}), exact: false },
            (previousPresets) => {
              const result = previousPresets?.my?.map((group) => {
                if (group.id === newGroup.id) {
                  return {
                    ...group,
                    name: newGroup.title,
                  };
                } else return group;
              });
              return { ...previousPresets, my: result };
            }
          );
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('rename group', e);
        }
      },
    }
  );

  const handleAction = async (group) => {
    const user = { name: currentUser.name, id: currentUser.id };

    const { title } = await showModal({
      title: 'Rename Group',
      initialValues: { ...group, title: group.name },
    });
    return renameMutation.mutateAsync({
      user,
      id: group.id,
      isPublic: group.isPublic,
      title,
    });
  };
  return [handleAction, renameMutation];
};
